import { OrganizationSelectComponent } from './organization-select.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonModule as NimbusCommonModule } from '../common/common.module';
import { DialogModule } from '../dialog';


@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule,
    DialogModule
  ],
  exports: [
    OrganizationSelectComponent
  ],
  declarations: [
    OrganizationSelectComponent
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class OrganizationsModule { }

export * from './organizations.actions';
